import { css } from '@emotion/react'
import { Spacing, ThemedColors, Typography, gemVar } from '@opallabs/gem'

export const modalContent = css({
  overflow: 'visible',
  inlineSize: '500px',
  maxInlineSize: '600px',
})

export const modalBody = css({
  overflow: 'inherit',
  display: 'flex',
  flexDirection: 'column',
  gap: Spacing.L,
})

export const infoSection = css({
  ...Typography.T500,
  backgroundColor: gemVar(ThemedColors.Surface2),
  color: gemVar(ThemedColors.TextSecondary),
  padding: Spacing.M,
  borderRadius: Spacing.XS,
  border: `1px solid ${gemVar(ThemedColors.StrokeSecondary1)}`,
})

export const infoText = css({
  margin: 0,
  lineHeight: 1.5,
})

export const section = css({
  display: 'flex',
  flexDirection: 'column',
  gap: Spacing.XS,
})

export const formElement = css({
  marginBlockStart: Spacing.M,
})

export const sectionTitle = css({
  margin: 0,
  fontSize: '16px',
  fontWeight: 600,
  color: gemVar(ThemedColors.TextPrimary),
})

export const sectionDescription = css({
  ...Typography.T500,
  margin: 0,
  fontSize: '14px',
  color: gemVar(ThemedColors.TextSecondary),
  lineHeight: 1.5,
})

export const radioGroup = css({
  marginBlockStart: Spacing.M,

  '& > *:not(:last-child)': {
    marginBlockEnd: Spacing.S,
  },
})

export const radioOption = css({
  display: 'flex',
  flexDirection: 'column',
  gap: Spacing.XS,
})

export const radioLabel = css({
  ...Typography.T500,
  fontWeight: 500,
  color: gemVar(ThemedColors.TextPrimary),
  cursor: 'pointer',
})

export const radioDescription = css({
  ...Typography.T500,
  color: gemVar(ThemedColors.TextSecondary),
  fontSize: '13px',
  lineHeight: 1.4,
  marginInlineStart: Spacing.XL,
  marginBlockEnd: Spacing.S,
})

export const dateRangeSection = css({
  marginBlockStart: Spacing.M,
  padding: Spacing.M,
  backgroundColor: gemVar(ThemedColors.Surface2),
  borderRadius: Spacing.XS,
  border: `1px solid ${gemVar(ThemedColors.StrokeSecondary1)}`,
})

export const datePickerRow = css({
  display: 'flex',
  gap: Spacing.M,
  alignItems: 'flex-end',
})

export const datePickerContainer = css({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: Spacing.XS,
})

export const datePickerLabel = css({
  ...Typography.T500,
  fontWeight: 500,
  color: gemVar(ThemedColors.TextPrimary),
  fontSize: '14px',
})

export const groupingSection = css({
  marginBlockStart: Spacing.M,
  padding: Spacing.M,
  backgroundColor: gemVar(ThemedColors.Surface2),
  borderRadius: Spacing.XS,
  border: `1px solid ${gemVar(ThemedColors.StrokeSecondary1)}`,
})

export const groupingTitle = css({
  ...Typography.T500,
  fontWeight: 600,
  color: gemVar(ThemedColors.TextPrimary),
  fontSize: '15px',
  marginBlockEnd: Spacing.S,
})

export const subSelection = css({
  marginBlockStart: Spacing.S,
  marginInlineStart: 0,
})

export const subSelectionNote = css({
  ...Typography.T500,
  color: gemVar(ThemedColors.TextSecondary),
  fontSize: '13px',
  fontStyle: 'italic',
})

export const nestedGroupingSection = css({
  marginBlockStart: Spacing.M,
  padding: Spacing.S,
  backgroundColor: gemVar(ThemedColors.Surface2),
  borderRadius: Spacing.XS,
  border: `1px solid ${gemVar(ThemedColors.StrokeSecondary1)}`,
})

export const nestedGroupingTitle = css({
  ...Typography.T500,
  fontWeight: 600,
  color: gemVar(ThemedColors.TextPrimary),
  fontSize: '14px',
  marginBlockEnd: Spacing.XS,
})
